import { render, staticRenderFns } from "./portafoglio.vue?vue&type=template&id=e756953c&scoped=true&"
import script from "./portafoglio.vue?vue&type=script&lang=ts&"
export * from "./portafoglio.vue?vue&type=script&lang=ts&"
import style0 from "./portafoglio.vue?vue&type=style&index=0&id=e756953c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e756953c",
  null
  
)

export default component.exports